import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IShiftTemplate } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ShiftTemplateService extends BaseService<IShiftTemplate> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'shiftTemplate');
  }
}

export { IShiftTemplate } from '../shared/api';
